import React from "react";
import TwoColumn from "../../../../Components/TwoColumn";
import Img from "../../../../assets/images/image";
import WhatMakesUsDifferent from "../../../../Components/WhatMakesUsDifferent";
import GetInTouch from "../../../../Components/GetInTouch";
import { data } from "../../../../Data/data";
import { Helmet } from "react-helmet";
import HeroSection from "../../../../Components/HeroSection/HeroSection";

export default function EnterpriseApplication() {
   return (
      <div className="animation fadeIn">
         <Helmet>
            <title>Enterprise Application</title>
            <meta
               name="description"
               content="We provide scalable solutions for enterprise-level challenges. You can trust in our stability, security & resilience for your next enterprise application."
            />
            <link rel="canonical" href="https://www.witmates.com/enterprise_app" />
         </Helmet>
         <div>
            <HeroSection
               image={Img.enterpriseApplicationBg}
               heading={
                  <>
                     We Create{" "}
                     <span className="witmates-theme-color">
                        Custom <br /> Enterprise{" "}
                     </span>{" "}
                     Applications <br /> for Business <span className="witmates-theme-color">Solutions</span>
                  </>
               }
               description={
                  <>
                     We understand the unique needs of businesses operating at an enterprise level, and our goal is to deliver scalable enterprise solutions. You can put your trust in our apps'
                     stability, security, and resilience as they are built to withstand the challenges of enterprise-level operations. By choosing our enterprise application services, you're
                     partnering with a team that is dedicated to understanding your unique business requirements and delivering solutions that align with your goals.
                  </>
               }
               link
            />
            <div id="contentMarketing" className="d-flex justify-content-center align-items-center pt100 pb100 mobPt50 mobPb20">
               <TwoColumn
                  image={Img.enterpriseAppDevGrid}
                  heading={
                     <>
                        Enterprise <br /> Application <br /> Development
                     </>
                  }
                  pageName="ENTERPRISE APPLICATION"
                  buttonName="BUILD TOGETHER"
                  redirection="/get-in-touch"
                  subPoints={["Custom Application Development", "Enterprise Mobility", "Application Modernisation"]}
                  isZoom={true}
                  description={
                     <>
                        Our enterprise application development services are designed with scalability, seamless integration, and outstanding performance as our top priorities. We understand the unique
                        business needs of enterprise-level applications, and we develop scalable solutions that meet those needs.
                        <br /> So, whether you're experiencing organic growth or looking for future expansion, our solutions are designed to scale seamlessly, providing you with the flexibility and
                        agility needed to adapt to changing market dynamics.
                        <br /> Throughout our process, we dive deep into understanding your target audience - their preferences, behaviours, and desires - ensuring that every design element serves a
                        purpose and revolves around their needs.
                        <br /> When it comes to performance and security, we go above and beyond to deliver reliable, secure, and robust solutions. To ensure that our enterprise applications perform
                        flawlessly under difficult circumstances, we leverage industry best practices, advanced technologies, and rigorous testing methodologies.
                        <br /> Our team follows industry-standard security practices and uses encryption, authentication, and access control mechanisms to protect your enterprise application against
                        unauthorized access, data breaches, and other security threats.
                        <br /> We are committed to driving your business growth and efficiency through our reliable, secure, and scalable enterprise applications. Let us help you unlock the full
                        potential of technology and grow your business to new heights of success.
                     </>
                  }
               />
            </div>
            <WhatMakesUsDifferent data={data.enterpriseApplicationData} height="365px" />
            <GetInTouch />
         </div>
      </div>
   );
}
